export const RESET = 'questions/RESET'
export const SUBMIT = 'questions/SUBMIT'
export const PREV = 'questions/PREV'
export const NEXT = 'questions/NEXT'
export const RESULT = 'questions/RESULT'
export const LANG = 'questions/LANG'




// WEBPACK FOOTER //
// ./src/questions/actionTypes.js